import React from 'react';
import './ButtonPrimary.css';

const ButtonPrimary = ({ children, onClick }) => {
  return (
    <button className="button-primary" onClick={onClick}>
      {children}
    </button>
  );
};

export default ButtonPrimary;